import React from "react";

interface FailedBatchesTableProps {
  selectedAll: boolean;
  onToggleSelectAll: (checked: boolean) => void;
}

const FailedBatchesTable: React.FC<FailedBatchesTableProps> = ({
  selectedAll,
  onToggleSelectAll,
}) => {
  return (
    <div className="card">
      <div className="card-body">
        <div className="report-table">
          <table className="table">
            <thead>
              <tr>
                <th>S.no.</th>
                <th>Queue Name</th>
                <th>Failed Reason</th>
                <th>Error Stack</th>
                <th>Job Id</th>
                <th>Status</th>
                <th>Created At</th>
                <th>Expire At</th>
                <th className="ng-star-inserted">
                  <input
                    type="checkbox"
                    checked={selectedAll}
                    onChange={(e) => onToggleSelectAll(e.target.checked)}
                  />
                  <button
                    className="btn btn-success btn-sm ml-2 btn-success2"
                    disabled
                  >
                    Process all jobs
                  </button>
                </th>
              </tr>
            </thead>
            {/* <tbody>
          <tr>
            <td colSpan={9} className="text-center">
              No data found.
            </td>
          </tr>
        </tbody> */}
          </table>
        </div>
      </div>
    </div>
  );
};

export default FailedBatchesTable;
